import {
    formatAppointmentDateTime,
    formatPatientName,
    getRowKey,
} from '../../cancellation-followups/subparts/cancellationFollowupChannel';

export const SURVEY_CHANNELS = [
    { key: 'email', label: 'Email', enabledKey: 'isEmail', contactKey: 'email', selectedKey: 'isEmailSelected' },
];

const hasContact = (record, channel) => Boolean(record?.[channel.contactKey]?.trim());

export const resolvePreferredChannel = (record) => (record?.isEmailSelected ? 'email' : null);

export const getChannelState = (record, channelKey) => {
    const channel = SURVEY_CHANNELS.find((item) => item.key === channelKey);
    if (!channel) {
        return { available: false, enabled: false, disabled: true };
    }

    const available = hasContact(record, channel);
    const surveyEnabled = record?.isSurvey !== false;
    const channelEnabled = record?.[channel.enabledKey] !== false;
    const disabled = !available || !surveyEnabled || !channelEnabled;

    return { available, enabled: surveyEnabled && channelEnabled, disabled };
};

export const buildDefaultChannelSelection = (record) => {
    const preferred = resolvePreferredChannel(record);

    if (preferred && !getChannelState(record, preferred).disabled) {
        return preferred;
    }

    const fallback = SURVEY_CHANNELS.find((channel) => !getChannelState(record, channel.key).disabled);
    return fallback?.key ?? null;
};

export const getRowChannelSelection = (channelSelections, rowKey, record) =>
    channelSelections[rowKey] ?? buildDefaultChannelSelection(record);

export const isRowSendable = (record) => {
    if (record?.isSurvey === false) {
        return false;
    }

    return SURVEY_CHANNELS.some((channel) => !getChannelState(record, channel.key).disabled);
};

export const getSendableRowKeys = (records) =>
    records.filter(isRowSendable).map((record) => getRowKey(record));

export { formatAppointmentDateTime, formatPatientName, getRowKey };
